
<!-- Drawer -->
<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040"
  [nzVisible]="ViewRequestVisible" [nzFooter]="footerTpl" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row d-print-block">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <h5 class="card-title">Request Details</h5>
        <div class="card-body">
          <div class="row">
            <div class="col">
              <label><b>Reference</b></label>
              <p>{{ ApproveRequest?.reference }}</p>
            </div>
            <div class="col">
              <label><b>Plant Name</b></label>
              <p>{{ ApproveRequest?.plantName }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Function</b></label>
              <p>{{ ApproveRequest?.sectionOrDepartment }}</p>
            </div>
            <div class="col">
              <label><b>Type</b></label>
              <p>{{ ApproveRequest?.type }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Expected Start Date</b></label>
              <p>{{ ApproveRequest?.startDate | date: 'dd MMMM yyyy' }}</p>
            </div>
            <div class="col">
              <label><b>Expected End Date</b></label>
              <p>{{ ApproveRequest?.endDate | date: 'dd MMMM yyyy' }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Number Required</b></label>
              <p>{{ ApproveRequest?.numberRequired }}</p>
            </div>
            <div class="col">
              <label><b>Job Description</b></label>
              <p>{{ ApproveRequest?.jobDescription }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Skills Required</b></label>
              <p>{{ ApproveRequest?.skillsRequired }}</p>
            </div>
            <div class="col">
              <label><b>Requested By</b></label>
              <p>{{ ApproveRequest?.requesterName }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label><b>Comment</b></label>
              <input name="" id="" [(ngModel)]="Comment" class="form-control" placeholder="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Approval History -->
  <div class="card-body">
    <h5 class="card-title">Approvals</h5>
    <div class="table-responsive">
      <table class="table table--striped table-hover">
        <thead>
          <tr>
            <th>Approved By</th>
            <th>Date Approved</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approval of RequestApprovals">
            <td>{{ approval.name }}</td>
            <td>{{ approval.approvalDate | date: 'dd MMMM yyyy hh:mm a' }}</td>
            <td>{{ approval.message }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!RequestApprovals?.length"
      style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
      <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
    </div>
  </div>

  <ng-template #footerTpl>
    <div style="float: right" class="d-print-none">
      <a (click)="approveContract()">
        <span style="margin-right: 8px;" class="btn btn-primary">Approve</span>
      </a>
      <a (click)="rejectContract()">
        <span style="margin-right: 8px;" class="btn btn-danger">Reject</span>
      </a>
      <button class="btn btn-light" style="margin-right: 8px;" (click)="close()">Close</button>
    </div>
  </ng-template>

  

</nz-drawer>

<!-- Main List -->
<h4 class="card-title"> Pending Approvals</h4>
<div class="table-responsive pt-3" *ngIf="adhocs?.length">
  <table class="table table--striped table-hover">
    <thead>
      <tr>
        <th>Reference</th>
        <th>Plant Name</th>
        <th>Function</th>
        <th>Type</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of adhocs" (click)="open(data)" class="clickable">
        <td>{{ data.reference }}</td>
        <td>{{ data.plantName }}</td>
        <td>{{ data.sectionOrDepartment }}</td>
        <td>{{ data.type }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div *ngIf="!adhocs?.length" style="text-align: center; padding: 18px;">
  <h4 style="color: rgba(128, 128, 128, 0.741);">You have no request pending approval</h4>
</div>
